import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { Select } from 'foundations-components/transitional/components/Select';
import { useAvailableSeats } from '../../../hooks/useAvailableSeats';
import { apiNameToSeatType } from '../../../lib/requests';
import { jsx as _jsx } from "react/jsx-runtime";
export const SeatSelector = ({
  apiName,
  setSelectedSeatType
}) => {
  const {
    data,
    error,
    loading
  } = useAvailableSeats();
  if (loading || error || data.availableSeatOptions.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "purchaseMotions.requestSeat.modal.seatInputSelect.title"
    }),
    children: /*#__PURE__*/_jsx(Select, {
      marginBlockEnd: "400",
      "data-test-id": `admin-only-modal-requestSeatUpgrade-new-seat-selector`,
      onChange: event => {
        setSelectedSeatType(event.target.value);
      },
      options: data.availableSeatOptions,
      defaultValue: apiNameToSeatType(apiName) || data.defaultSeat
    })
  });
};